import { render, staticRenderFns } from "./PmContent.vue?vue&type=template&id=5103d086&scoped=true&"
import script from "./PmContent.vue?vue&type=script&lang=js&"
export * from "./PmContent.vue?vue&type=script&lang=js&"
import style0 from "./PmContent.vue?vue&type=style&index=0&id=5103d086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103d086",
  null
  
)

export default component.exports